module.exports = __webpack_public_path__ + "static/media/uber_logo_black.eb8e8685.svg";